export default __webpack_public_path__ + "static/media/wall-prat-2.2f846729.JPG";